export class LogAnalysisState {
    cachedImages = new Map<string, string>();
    constructor() {}
}

export default new LogAnalysisState();
